<template>
  <el-dialog width="40%" title="纠错" :visible="visible" @close="closeDialog">
    <el-form
      :model="errorData"
      style="height: 500px; overflow: auto"
      label-position="left"
      label-width="150px"
    >
      <el-form-item label="姓氏">
        <el-input v-model="errorData.surName"></el-input>
      </el-form-item>
      <el-form-item label="迁徙人物">
        <el-input v-model="errorData.personalName"></el-input>
      </el-form-item>
      <el-form-item label="时间">
        <el-input v-model="errorData.migrateDate"></el-input>
      </el-form-item>
      <el-form-item label="时间（公元纪年）">
        <el-input v-model="errorData.migrateDateYear"></el-input>
      </el-form-item>
      <el-form-item label="迁出地（古地名）">
        <el-input v-model="errorData.beginPlace"></el-input>
      </el-form-item>
      <el-form-item label="迁出地（现行政区划地址）">
        <el-input v-model="errorData.beginPlaceAddress"></el-input>
      </el-form-item>
      <el-form-item label="迁入地（古地名）">
        <el-input v-model="errorData.endPlace"></el-input>
      </el-form-item>
      <el-form-item label="迁入地（现行政区划地址）">
        <el-input v-model="errorData.endPlaceAddress"></el-input>
      </el-form-item>
      <el-form-item label="散居地">
        <el-input v-model="errorData.diaspora"></el-input>
      </el-form-item>
      <el-form-item label="原文摘录">
        <el-input
          type="textarea"
          rows="5"
          v-model="errorData.sourceText"
        ></el-input>
      </el-form-item>
      <el-form-item label="纠错依据">
        <el-upload
          action="/"
          list-type="picture-card"
          :on-change="uploadChange"
          :file-list="fileList"
          :auto-upload="false"
          :on-remove="handleRemove"
          multiple
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="errorData.correctRemark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="onconfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { uploadImage, correct } from "@/api/drillingIn";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    errorData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    closeDialog() {
      this.$emit("update:visible", false);
    },
    uploadChange(file, fileList) {
      this.fileList = fileList;
    },
    onconfirm() {
      const formData = new FormData();
      this.fileList.forEach((file) => {
        if (file.raw) {
          formData.append("formFiles", file.raw);
        }
      });
      uploadImage(formData, { uploadType: 3 })
        .then((res) => {
          correct({
            ...this.errorData,
            bases: res,
          });
        })
        .then(() => {
          this.$message.success("操作成功");
          this.closeDialog();
        })
        .catch((e) => {
          console.error(e);
          this.$message.error("操作失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
